import { encryptDataWithRootState, encryptFileWithRootState } from './store.js';
import { getStore } from '../../store/helpers/initStore.js';

/**
 * Methods requiring store access are located here to prevent dependency cycles.
 * These methods should not be called from store modules.
 */
/**
 * Encrypt any given data
 * @param data Data that needs to be encrypted
 * @param inputAccessAttributes Attributes of users with access to encrypted data
 * @return {Promise<EncryptedData>}
 */
const encryptData = async (data, inputAccessAttributes) => encryptDataWithRootState(data, getStore().state, inputAccessAttributes);
/**
 * Encrypt any file
 * @param inputFile File to encrypt
 * @param metadata Decrypted file metadata (for later reconstruction)
 * @param uploadAction Function to upload blob and resolve a data URL
 * @param inputAccessAttributes Attributes of users with access to encrypted data
 * @return {Promise<EncryptedFile>} Encrypted File object
 */
const encryptFile = async (inputFile, metadata, uploadAction, inputAccessAttributes) => encryptFileWithRootState(inputFile, metadata, uploadAction, getStore().state, inputAccessAttributes);

export { encryptData, encryptFile };
